/* eslint-disable @typescript-eslint/no-explicit-any */
import { PreviewMessageType, sendMessage, } from "@dcl/schemas/dist/dapps/preview";
import { default as future } from "fp-future";
import mitt from "mitt";
const promises = new Map();
const emoteEvents = new Map();
window.onmessage = function handleMessage(event) {
    if (event.data && event.data.type) {
        switch (event.data.type) {
            case PreviewMessageType.CONTROLLER_RESPONSE: {
                const payload = event.data
                    .payload;
                const { id } = payload;
                const promise = promises.get(id);
                if (promise) {
                    if (payload.ok) {
                        promise.resolve(payload.result);
                    }
                    else if (payload.ok === false) {
                        promise.reject(new Error(payload.error));
                    }
                }
                break;
            }
            case PreviewMessageType.EMOTE_EVENT: {
                const payload = event.data
                    .payload;
                const { type, payload: eventPayload } = payload;
                const events = event.source ? emoteEvents.get(event.source) : null;
                if (events && type) {
                    events.emit(type, eventPayload);
                }
                break;
            }
            default:
            // nothing to do, invalid message
        }
    }
};
let nonce = 0;
function createSendRequest(id) {
    return function sendRequest(namespace, method, params) {
        const iframe = document.getElementById(id);
        const messageId = id + "-" + nonce;
        const promise = future();
        promises.set(messageId, promise);
        const type = PreviewMessageType.CONTROLLER_REQUEST;
        const message = { id: messageId, namespace, method, params };
        if (iframe.contentWindow) {
            sendMessage(iframe.contentWindow, type, message);
        }
        nonce++;
        return promise;
    };
}
export function createController(id) {
    const iframe = document.getElementById(id);
    if (!iframe) {
        throw new Error(`Could not find an iframe with id="${id}"`);
    }
    const events = iframe.contentWindow
        ? emoteEvents.get(iframe.contentWindow) ?? mitt()
        : mitt();
    if (iframe.contentWindow) {
        emoteEvents.set(iframe.contentWindow, events);
    }
    const sendRequest = createSendRequest(id);
    return {
        scene: {
            getScreenshot(width, height) {
                return sendRequest("scene", "getScreenshot", [width, height]);
            },
            getMetrics() {
                return sendRequest("scene", "getMetrics", []);
            },
            changeZoom: function (zoom) {
                return sendRequest("scene", "changeZoom", [zoom]);
            },
            panCamera: function (offset) {
                return sendRequest("scene", "panCamera", [offset]);
            },
            changeCameraPosition: function (position) {
                return sendRequest("scene", "changeCameraPosition", [position]);
            },
            cleanup() {
                return sendRequest("scene", "cleanup", []);
            },
            setUsername: function (username) {
                return sendRequest("scene", "setUsername", [username]);
            },
        },
        emote: {
            getLength() {
                return sendRequest("emote", "getLength", []);
            },
            isPlaying() {
                return sendRequest("emote", "isPlaying", []);
            },
            goTo(seconds) {
                return sendRequest("emote", "goTo", [seconds]);
            },
            play() {
                return sendRequest("emote", "play", []);
            },
            pause() {
                return sendRequest("emote", "pause", []);
            },
            stop() {
                return sendRequest("emote", "stop", []);
            },
            enableSound() {
                return sendRequest("emote", "enableSound", []);
            },
            disableSound() {
                return sendRequest("emote", "disableSound", []);
            },
            hasSound() {
                return sendRequest("emote", "hasSound", []);
            },
            events,
        },
    };
}
//# sourceMappingURL=WearablePreview.controller.js.map